import { dataLayerConfig } from '@aspendental/shared-components-web';
import { DateTextInput, MaskedPhoneNumberInput, TextInput } from '@aspendental/shared-forms-web';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { personalInfoForm } from './PersonalInfo.helpers';
import { HydraState } from '@src/constants';
import { usePatientInformationStore } from '@src/store';
import useAppointmentInformationStore from '@src/store/appointment-information.store';
export default function PersonalInfo() {
  const {
    t
  } = useTranslation('index');
  const {
    leadId
  } = usePatientInformationStore(store => store);
  useAppointmentInformationStore();
  useEffect(() => {
    dataLayerConfig({
      event: 'appointment_step',
      step_name: 'patient_information',
      step_sequence: 2,
      lead_id: leadId,
      lead_tier: null,
      lead_segment: null,
      hydra_status: HydraState.ON
    });
  }, []);
  return <>
			<Typography variant="header4" color="text.primary" data-sentry-element="Typography" data-sentry-source-file="PersonalInfo.tsx">
				{t('personalInfo')}
			</Typography>
			<Grid container spacing={{
      md: 2.5,
      xs: 1.7
    }} pt={{
      md: 2.5,
      xs: 1.7
    }} data-sentry-element="Grid" data-sentry-source-file="PersonalInfo.tsx">
				<Grid item xs={6} md={6} data-sentry-element="Grid" data-sentry-source-file="PersonalInfo.tsx">
					<TextInput name={personalInfoForm.firstName.name} label={t(personalInfoForm.firstName.labelKey)} data-private data-sentry-element="TextInput" data-sentry-source-file="PersonalInfo.tsx" />
				</Grid>
				<Grid item xs={6} md={6} data-sentry-element="Grid" data-sentry-source-file="PersonalInfo.tsx">
					<TextInput name={personalInfoForm.lastName.name} label={t(personalInfoForm.lastName.labelKey)} data-private data-sentry-element="TextInput" data-sentry-source-file="PersonalInfo.tsx" />
				</Grid>
				<Grid item xs={12} md={6} data-private data-sentry-element="Grid" data-sentry-source-file="PersonalInfo.tsx">
					<DateTextInput label={t(personalInfoForm.dateOfBirth.labelKey)} name={personalInfoForm.dateOfBirth.name} autoComplete="bday" required data-sentry-element="DateTextInput" data-sentry-source-file="PersonalInfo.tsx" />
				</Grid>
				<Grid item xs={12} data-sentry-element="Grid" data-sentry-source-file="PersonalInfo.tsx">
					<TextInput name={personalInfoForm.email.name} label={t(personalInfoForm.email.labelKey)} enforceAlphaNumeric={false} placeholder={t('emailPlaceholder')} data-private data-sentry-element="TextInput" data-sentry-source-file="PersonalInfo.tsx" />
				</Grid>
				<Grid item xs={12} md={6} data-sentry-element="Grid" data-sentry-source-file="PersonalInfo.tsx">
					<MaskedPhoneNumberInput name={personalInfoForm.phone.name} label={t(personalInfoForm.phone.labelKey)} data-private data-sentry-element="MaskedPhoneNumberInput" data-sentry-source-file="PersonalInfo.tsx" />
				</Grid>
			</Grid>
		</>;
}